import React from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  useTheme,
  useMediaQuery
} from "@mui/material";

export default function CommonTableHeaders() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const headerCellStyle = {
    fontWeight: 600,
    fontSize: isMobile ? '0.75rem' : '0.875rem',
    color: 'primary.contrastText',
    bgcolor: 'primary.main',
    py: isMobile ? 1.5 : 2,
    px: isMobile ? 1 : 2,
    borderBottom: 'none',
    position: 'sticky',
    top: 0,
    zIndex: 1
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell 
          align="left"
          sx={headerCellStyle}
        >
          Player Details
        </TableCell>
        <TableCell 
          align="center"
          sx={{
            ...headerCellStyle,
            display: { xs: 'none', sm: 'table-cell' }
          }}
        >
          Request Time
        </TableCell>
        <TableCell 
          align="center"
          sx={headerCellStyle}
        >
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
